// Override Mantine Popover dropdown styles to remove default padding/border/background
// Our custom card component already has these styles
.dropdown {
  padding: 0;
  border: none;
  background: transparent;
}
